<template>
  <v-autocomplete
    ref="countryRef"
    class="search-bak"
    :items="countries"
    @input="input"
    hide-no-data
    item-text="name"
    item-value="name"
    dense
    outlined
    placeholder="Start typing to countries"
    label="Country"
    autocomplete="off"
    :value="value"
    v-on="listeners"
    v-bind="attrs"
  >
    <template v-slot:label>
      {{attrs.label || 'Country'}}
      <span v-if="required" class="red--text">*</span>
    </template>
  </v-autocomplete>
</template>
<script>
// import CoreMixin from '@/mixins/core.mixin';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'CountryPicker',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: ''
    }
  },
  
  computed: {
    ...mapGetters('coreModule', ['countries']),

    listeners() {
      const { ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { ...attrs } = this.$attrs;
      return attrs;
    }
  },

  watch: {
    value: {
      handler(val) {
        if (val) {
          this.getCountryProvinces(val);
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('coreModule', ['getCountryProvinces']),

    input(event) {
      this.getCountryProvinces(event);
      this.$emit('input', event);
    },

    blur(event) {
      this.$emit('blur', event);
    }
  }
};
</script>

